class FacetDelete extends window.BAO.CustomElement() {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick)
  }

  connectedCallback () {
    this.setupListeners()
  }

  handleClick (e) {
    e.preventDefault()

    const facet = this.dataset.facet
    const option = this.dataset.value

    this.eventBus.publish('facets-list:remove-filter', {
      facet,
      option,
    })
  }
}

window.customElements.define('facet-delete', FacetDelete)
